import React from "react";
import { Type } from "@ebscois/react-component-library";
import PropTypes from "prop-types";

const ConsentError = ({ error }) => {
  const isJwtError = error?.status === 401 && error?.message;
  const jwtErrorMessage = error?.errorCode === "CONSENT_TOKEN_EXPIRED"
    ? "Your registration session has expired."
    : "Your registration session is no longer valid.";

  return (
    <div>
      <Type
        element="p"
        fontSize="sm"
        fontFamily="secondary"
        display="block"
        fontWeight="semibold"
      >
        {isJwtError
          ? jwtErrorMessage
          : "We're sorry! The consent service is temporarily unavailable."}
      </Type>
      <Type
        element="p"
        fontSize="sm"
        fontFamily="secondary"
        fontWeight="semibold"
      >
        {isJwtError
          ? "Please return to the registration page and submit your details again."
          : "We are working on resolving the problem. Please try again shortly."}
      </Type>
    </div>
  );
};

ConsentError.displayName = "ConsentError";

ConsentError.propTypes = {
  error: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
    PropTypes.shape({
      status: PropTypes.number,
      errorCode: PropTypes.string,
      message: PropTypes.string,
    }),
  ]),
};

export default ConsentError;
